<!-- Pager -->
<div class='col-md-7 col-sm-5 col-xs-5 viewer-page-mode-container btn-toolbar' role="toolbar" aria-label="Search hit pager">
	<div *ngIf="documentData['hitHighlightable'] && documentData['searchHitData'].hasHit" class="hidden-xs btn-group pager-group" role="group">
	    <a (click)='prevHit()' [ngClass]="{'disabled' : !hasPrevMarkup()}" title="{{LOCALIZATION.previousHighlight}}" class="viewer-pager pointMe">
	        <i class="fa fa-angle-double-left"></i><span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.previous}}</span>
	    </a>
	    <a (click)='nextHit()' [ngClass]="{'disabled' : !hasNextMarkup()}" title="{{LOCALIZATION.nextHighlight}}" class="viewer-pager pointMe">
	        <span class="hidden-md hidden-sm hidden-xs">{{LOCALIZATION.next}}</span><i class="fa fa-angle-double-right"></i>
	    </a>
		<em class="hidden-md hidden-sm hidden-xs">
			{{LOCALIZATION.XofNHighlights | formatString: documentData['searchHitData'].currentHighlight+1 : documentData['searchHitData'].highlightsTotal }}
		</em>
	</div>
</div>

<!-- Content display -->
<div style='width:100%; height:100%;'>
	<iframe #textIframe
		 [hidden]="documentAttachments.length > 0 || viewerURL == null"
		 id='textViewer' 
		 [src]="viewerURL" 
		 width="100%" height="100%" 
		 sandbox="allow-top-navigation-by-user-activation allow-scripts allow-popups allow-same-origin" 
		 (load)="text_viewer_onload($event)">
	</iframe>
	
	<div *ngIf="documentAttachments.length > 0" style="height:95%">
	    <div>
	        <ul class="nav nav-tabs">
	            <li [ngClass]="{active: attachmentsTabIndex === 0}" class="nav-item">
	                <a href="" (click)="attachmentsTabIndex = 0; $event.preventDefault()" class="nav-link">{{LOCALIZATION.message}}</a>
	            </li>
	            <li [ngClass]="{active: attachmentsTabIndex === 1}" class="nav-item">
	                <a href="" (click)="attachmentsTabIndex = 1; $event.preventDefault()" class="nav-link">{{LOCALIZATION.attachments}}</a>
	            </li>
	        </ul>
	    </div>
	    <div style="height:100%">
	        <div *ngIf="attachmentsTabIndex === 0" style="height:100%">
<!-- 	        	NOTE: Overviews of TEXT type docs (ppt, doc, etc) can be provided as direct PDF URLs. Loading such URLs -->
<!-- 	        	directly into an iframe (rather than using PDFjs) will fail without proper CORS config. -->
	            <iframe [hidden]="viewerURL == null" id='pdfAttachmentViewer' [src]="viewerURL" width="100%" height="100%"></iframe>
	        </div>
	        <div *ngIf="attachmentsTabIndex === 1">
	            <div *ngFor="let attachment of documentAttachments" class="row"> 
	            	<div class="col-xs-12"><a [href]="attachment.url" download="{{attachment.name}}">{{LOCALIZATION.download}} {{attachment.name}}</a></div>
	            </div>
	        </div>
	    </div>
	</div>
</div>
